import { render, staticRenderFns } from "./DocumentPhotoIndex.vue?vue&type=template&id=78f34c4b&scoped=true&"
import script from "./DocumentPhotoIndex.vue?vue&type=script&lang=js&"
export * from "./DocumentPhotoIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f34c4b",
  null
  
)

export default component.exports